// This module provides API call methods for Sephora Stay Signed-in APIs:
// https://jira.sephora.com/wiki/display/ILLUMINATE/Stay+Signed-in+Specification

const { autoLogin } = require('./autoLogin');


module.exports = {
    autoLogin
};
